urls = {
  contactUsApi: [
    'https://dpa.esri.com/api/getOfficesForCountry/',
    'https://webopsapi.esri.com/Applications/EsriLocations/GetOfficesForCountry/',
    'https://dpastg.esri.com/api/getOfficesForCountry/',
    'https://dpadev.esri.com/api/getOfficesForCountry/'
  ]  
}
window.urls = urls;

contactUsData = {
  settings:{
    enableGetDirectionsRoutingPopup:false,
    translateToLocalLanguage:false
  },
  getDirectionsRoutingPopupMapUrl:'https://webapps-cdn-dev.esri.com/tools/directions-2-esri-modal/?',
  getDistributorContactDetailsApiUrl: urls.contactUsApi[0],
  textCopy:{
    default:{
      headingSubtitleAddress:"Redlands, CA, USA",
      headingSubtitleServes:"Serves the United States",
      mainOfficeTabTitle:"General Questions",
      mainOfficeTabSubtitle:"We are here to help with any questions.",
      mainOfficeTabSubtitle_:["We are here to help with any questions"],

      mainOfficeOurLocationTitle:"Redlands Visitor Map",
      mainOfficeOurLocationSubtitle:"Explore a local map of hotels, restaurants, and services",
      mainOfficeOurLocationAnchor:"http://www.esri.com/about-esri/campusmap", // https breaks the map
      mainOfficeOurLocationAction:"View map",
      ctaPhoneTitle:"Call us",
      ctaPhoneSubtitle:"During business hours",
      ctaWebsiteTitle:"",
      ctaWebsiteSubtitle:"Explore the website",
      ctaWebsiteAction:"View website",
      salesTabTitle:"Sales",
      salesTabSubtitle: "<ul>"+
      "<li>Request pricing or place an order</li>"+
      "<li>Evaluate a product</li>"+
      "<li>Get detailed product information</li>"+
      "</ul>",
      salesTabSubtitle_: [
        'Request pricing or place an order',
        'Evaluate a product',
        'Get detailed product information'
      ],
      salesEmailTitle:"Contact Sales",
      salesEmailSubtitle:"We are here to help.",
      ctaChatTitle:"Chat now",
      ctaChatSubtitle:"Begin a conversation online",
      ctaChatAnchor:"http://www.esri.com/common/chat/EsriBoldChatForm.html",
      salesCtaChatAnchor:"http://www.esri.com/common/chat/EsriBoldChatForm.html",
      techSupportCtaChatAnchor:"https://support.esri.com/start-chat",
      ctaChatAction:"Start chat",
      ctaEsriStoreTitle:"Esri Store",
      ctaEsriStoreSubitle:"Explore ArcGIS products and extensions in the Esri Store",
      ctaEsriStoreAnchor:"https://www.esri.com/en-us/store",
      ctaEsriStoreAction:"Shop now",
      ctaArcgisForStudentUseTitle:"ArcGIS for Student Use",
      ctaArcgisForStudentUseSubtitle:"Get started with an educational license",
      ctaArcgisForStudentUseAnchor:"https://www.esri.com/en-us/arcgis/products/arcgis-for-student-use",
      ctaArcgisForStudentUseAction:"Get student license",
      consultingTabTitle:"Consulting",
      consultingTabSubtitle:"<ul>"+
      "<li>Project management and delivery</li>"+
      "<li>Enterprise strategy and implementation</li>"+
      "<li>Installation and configuration specialists</li>"+
      "</ul>",
      consultingTabSubtitle_:[
        'Project management and delivery',
        'Enterprise strategy and implementation',
        'Installation and configuration specialists'
      ],
      consultingEmailTitle:"Contact Consulting",
      consultingEmailSubtitle:"We are here to help.",
      ctaConsultingServicesTitle:"Consulting Services",
      ctaConsultingServicesSubtitle:"Expert GIS advice and hands-on help customized for your needs",
      ctaConsultingServicesAnchor:"https://www.esri.com/en-us/arcgis/services/consulting",
      ctaConsultingServicesAction:"View consulting options",
      customerServiceTabTitle:"Customer Service",
      customerServiceTabSubtitle:"<ul>"+
      "<li>Get help if you’re not sure who to talk to</li>"+
      "<li>Inquire about an order or renew your maintenance</li>"+
      "<li>Software downloads</li>"+
      "</ul>",
      customerServiceTabSubtitle_:[
          'Get help if you’re not sure who to talk to',
          'Inquire about an order or renew your maintenance',
          'Software downloads'
      ],
      customerServiceEmailTitle:"Contact Customer Service",
      customerServiceEmailSubtitle:"We are here to help.",
      ctaMyesriTitle:"My Esri",
      ctaMyesriSubtitle:"Access your account",
      ctaMyesriAnchor:"https://my.esri.com",
      ctaMyesriAction:"Sign in",
      technicalSupportTabTitle:"Technical Support",
      technicalSupportTabSubtitle:"<ul>"+
      "<li>Find answers to your ArcGIS related questions</li>"+
      "<li>Report a bug or ArcGIS Online service disruption</li>"+
      "<li>Software troubleshooting</li>"+
      "</ul>",
      technicalSupportTabSubtitle_:[
          'Find answers to your ArcGIS related questions',
          'Report a bug or ArcGIS Online service disruption',
          'Software troubleshooting'
      ],
      ctaOnlineResourcesTitle:"Online resources",
      ctaOnlineResourcesSubtitle:"Explore the knowledge base to answer your questions",
      ctaOnlineResourcesAnchor:"https://support.esri.com/en/knowledge-base",
      ctaOnlineResourcesAction:"Start search",
      technicalSupportEmailTitle:"Contact Technical Support",
      technicalSupportEmailSubtitle:"We are here to help.",
      ctaDownloadsTitle:"Downloads",
      ctaDownloadsSubtitle:"Software updates, patches, and more",
      ctaDownloadsAnchor:"https://support.esri.com/en/downloads",
      ctaDownloadsAction:"View available fixes",
      ctaRequestSupportTitle:"Request case",
      ctaRequestSupportSubtitle:"Get help with Esri products (for qualifying accounts)",
      ctaRequestSupportAnchor:"https://support.esri.com/request-case",
      ctaRequestSupportAction:"Open a new case",
      trainingTabTitle:"Training",
      trainingTabSubtitle:"<ul>"+
      "<li>Courses to get started with ArcGIS</li>"+
      "<li>Purchase a training pass</li>"+
      "<li>Change management consultation</li>"+
      "</ul>",
      trainingTabSubtitle_:[
          'Courses to get started with ArcGIS',
          'Purchase a training pass',
          'Change management consultation'
      ],
      trainingEmailTitle:"Contact Training",
      trainingEmailSubtitle:"We are here to help.",
      ctaEsriTrainingTitle:"Esri Training",
      ctaEsriTrainingSubtitle:"Find classes and organize learning programs",
      ctaEsriTrainingAnchor:"https://www.esri.com/training",
      ctaEsriTrainingAction:"View training options",
      ctaCatalogTitle:"Catalog",
      ctaCatalogSubtitle:"Explore all instructor-led classes and self-paced e-learning",
      ctaCatalogAnchor:"https://www.esri.com/training/catalog/search/",
      ctaCatalogAction:"Search the catalog",
      ctaCertificationTitle:"Technical Certification",
      ctaCertificationSubtitle:"Certify that you are proficient in best practices for using ArcGIS",
      ctaCertificationAnchor:"https://www.esri.com/training/certification/",
      ctaCertificationAction:"Get certified",
      locationSearchTitle:"Not the office you’re looking for?",
      locationSearchInputPlaceholder:"Search locations"
    },
    us:{
      ctaPhoneSubtitle:"9am - 5pm PT, Monday&ndash;Friday"
    }
  },
  data:{
    us:{
      Distributor_Name:"Esri Headquarters",
      Address_1:"380 New York Street",
      Address_2:"",
      City:"Redlands",
      State_Prov:"CA",
      Country:"USA",
      Zip_Postal:"",
      Main_Phone_Number:"+1 909 793 2853",
      Main_Phone_Hours:"9am - 5pm PT, Monday&ndash;Friday",
      General_Email:"",
      Website:"www.esri.com",
      Sales_Phone_Number:"+1 800 447 9778",
      Sales_Phone_Hours:"7am - 5pm PT, Monday&ndash;Friday",
      Sales_Email:"",
      Sales_Website:"",
      Tech_Support_Phone:"+1 888 377 4575 opt 2",
      Tech_Support_Phone_Hours:"5am - 5pm PT, Monday&ndash;Friday",
      Tech_Support_Email:"",
      Tech_Support_Website:"",
      Training_Phone:"+1 888 377 4575 opt 3",
      Training_Phone_Hours:"9am - 5pm PT, Monday&ndash;Friday",
      Training_Email:"",
      Training_Website:"",
      Customer_Service_Phone:"+1 888 377 4575 opt 5",
      Customer_Service_Phone_Hours:"5am - 5pm PT, Monday&ndash;Friday",
      Customer_Service_Email:"",
      Customer_Service_Website:"",
      Consulting_Phone:"+1 888 377 4575",
      Consulting_Phone_Hours:"9am - 5pm PT, Monday&ndash;Friday",
      Consulting_Email:"",
      Consultinge_Website:"",
      Countries_Served:[],
      Primary_Distributor_Name:"",
      Regional_Office:false,
      SubDistributor:false,
      CountriesServed: [
          'USA',
          'ASM',
          'AND',
          'ATA',
          'BVT',
          'CYM',
          'CAF',
          'CXR',
          'CCK',
          'COM',
          'FLK',
          'GIB',
          'GNQ',
          'GUM',
          'HTI',
          'HMD',
          'IRN',
          'KIR',
          'PRK',
          'MDV',
          'MHL',
          'FSM',
          'NRU',
          'NIU',
          'NFK',
          'MNP',
          'PLW',
          'SYC',
          'SLE',
          'SOM',
          'SJM',
          'TKL',
          'TUV'
      ]
    }
  },
  schema:{
    Distributor_Name:"",
    Address_1:"",
    Address_2:"",
    City:"",
    State_Prov:"",
    Country:"",
    Zip_Postal:"",
    Main_Phone_Number:"",
    General_Email:"",
    Website:"",
    Sales_Phone_Number:"",
    Sales_Email:"",
    Sales_Website:"",
    Tech_Support_Phone:"",
    Tech_Support_Email:"",
    Tech_Support_Website:"",
    Training_Phone:"",
    Training_Email:"",
    Training_Website:"",
    Customer_Service_Phone:"",
    Customer_Service_Email:"",
    Customer_Service_Website:"",
    Countries_Served:[],
    Primary_Distributor_Name:"",
    Regional_Office:false,
    SubDistributor:false
  },
  default: {
    hash:"",
    country:"United States",
    alpha2:"us",
    countryCode:"us",
    countryObj:{
      "ip": "198.102.62.250",
      "country_code": "US",
      "country_name": "United States of America",
      "region_code": "CA",
      "region_name": "California",
      "city": "Redlands",
      "zip_code": "92373",
      "time_zone": "America/Los_Angeles",
      "latitude": 34.0008,
      "longitude": -117.1266,
      "metro_code": 803
    },
    data: [
      {
      "id": 31,
      "companyName": "Esri Headquarters",
      "officeName": "",
      "address1": "380 New York Street",
      "address2": "Redlands, California 92373",
      "address3": "",
      "pOBox1": "",
      "pOBox2": "",
      "city": "",
      "stateProvince": "",
      "postalCode": "92373-8100",
      "country": "USA",
      "officeType": "Corporate office",
      "contact": "",
      "contact2": "",
      "contact3": "",
      "showContact3": false,
      "email": "",
      "email2": "",
      "email3": "",
      "showEmail3": false,
      "phone": "1-909-793-2853",
      "fax": "1-909-307-3025",
      "website": "www.esri.com",
      "infoAbove": "",
      "showInfoAbove": false,
      "infoBelow": "",
      "showInfoBelow": false,
      "extraInfo": "",
      "showExtraInfo": false
      }       
    ]
  },
  usStateCodeList:[
    { code: "US-AL", name:"Alabama", type:"state" },
    { code: "US-AK", name:"Alaska", type:"state" },
    { code: "US-AZ", name:"Arizona", type:"state" },
    { code: "US-AR", name:"Arkansas", type:"state" },
    { code: "US-CA", name:"California", type:"state" },
    { code: "US-CO", name:"Colorado", type:"state" },
    { code: "US-CT", name:"Connecticut", type:"state" },
    { code: "US-DE", name:"Delaware", type:"state" },
    { code: "US-FL", name:"Florida", type:"state" },
    { code: "US-GA", name:"Georgia", type:"state" },
    { code: "US-HI", name:"Hawaii", type:"state" },
    { code: "US-ID", name:"Idaho", type:"state" },
    { code: "US-IL", name:"Illinois", type:"state" },
    { code: "US-IN", name:"Indiana", type:"state" },
    { code: "US-IA", name:"Iowa", type:"state" },
    { code: "US-KS", name:"Kansas", type:"state" },
    { code: "US-KY", name:"Kentucky", type:"state" },
    { code: "US-LA", name:"Louisiana", type:"state" },
    { code: "US-ME", name:"Maine", type:"state" },
    { code: "US-MD", name:"Maryland", type:"state" },
    { code: "US-MA", name:"Massachusetts", type:"state" },
    { code: "US-MI", name:"Michigan", type:"state" },
    { code: "US-MN", name:"Minnesota", type:"state" },
    { code: "US-MS", name:"Mississippi", type:"state" },
    { code: "US-MO", name:"Missouri", type:"state" },
    { code: "US-MT", name:"Montana", type:"state" },
    { code: "US-NE", name:"Nebraska", type:"state" },
    { code: "US-NV", name:"Nevada", type:"state" },
    { code: "US-NH", name:"New Hampshire", type:"state" },
    { code: "US-NJ", name:"New Jersey", type:"state" },
    { code: "US-NM", name:"New Mexico", type:"state" },
    { code: "US-NY", name:"New York", type:"state" },
    { code: "US-NC", name:"North Carolina", type:"state" },
    { code: "US-ND", name:"North Dakota", type:"state" },
    { code: "US-OH", name:"Ohio", type:"state" },
    { code: "US-OK", name:"Oklahoma", type:"state" },
    { code: "US-OR", name:"Oregon", type:"state" },
    { code: "US-PA", name:"Pennsylvania", type:"state" },
    { code: "US-RI", name:"Rhode Island", type:"state" },
    { code: "US-SC", name:"South Carolina", type:"state" },
    { code: "US-SD", name:"South Dakota", type:"state" },
    { code: "US-TN", name:"Tennessee", type:"state" },
    { code: "US-TX", name:"Texas", type:"state" },
    { code: "US-UT", name:"Utah", type:"state" },
    { code: "US-VT", name:"Vermont", type:"state" },
    { code: "US-VA", name:"Virginia", type:"state" },
    { code: "US-WA", name:"Washington", type:"state" },
    { code: "US-WV", name:"West Virginia", type:"state" },
    { code: "US-WI", name:"Wisconsin", type:"state" },
    { code: "US-WY", name:"Wyoming", type:"state" },
    { code: "US-DC", name:"District of Columbia	", type:"district" },
    { code: "US-AS", name:"American Samoa", type:"outlying area" },
    { code: "US-GU", name:"Guam", type:"outlying area" },
    { code: "US-MP", name:"Northern Mariana Islands", type:"outlying area" },
    { code: "US-PR", name:"Puerto Rico", type:"outlying area" },
    { code: "US-UM", name:"United States Minor Outlying Islands", type:"outlying area" },
    { code: "US-VI", name:"Virgin Islands, U.S.", type:"outlying area" }
  ],
  countryAlpha3List:[
    { alpha2: "AF", alpha3: "AFG", name: "Afghanistan" },
    { alpha2: "AL", alpha3: "ALB", name: "Albania" },
    { alpha2: "DZ", alpha3: "DZA", name: "Algeria", aliases:["Algérie"] },
    { alpha2: "AS", alpha3: "ASM", name: "American Samoa" },
    { alpha2: "AD", alpha3: "AND", name: "Andorra" },
    { alpha2: "AO", alpha3: "AGO", name: "Angola" },
    { alpha2: "AI", alpha3: "AIA", name: "Anguilla" },
    { alpha2: "AQ", alpha3: "ATA", name: "Antarctica" }, 
    { alpha2: "AG", alpha3: "ATG", name: "Antigua and Barbuda" },
    { alpha2: "AR", alpha3: "ARG", name: "Argentina" },
    { alpha2: "AM", alpha3: "ARM", name: "Armenia" },
    { alpha2: "AW", alpha3: "ABW", name: "Aruba" },
    { alpha2: "AU", alpha3: "AUS", name: "Australia" },
    { alpha2: "AT", alpha3: "AUT", name: "Austria" },
    { alpha2: "AZ", alpha3: "AZE", name: "Azerbaijan" },
    { alpha2: "BH", alpha3: "BHR", name: "Bahrain" },
    { alpha2: "BD", alpha3: "BGD", name: "Bangladesh" },
    { alpha2: "BB", alpha3: "BRB", name: "Barbados" },
    { alpha2: "BY", alpha3: "BLR", name: "Belarus" },
    { alpha2: "BE", alpha3: "BEL", name: "Belgium" },
    { alpha2: "BZ", alpha3: "BLZ", name: "Belize" },
    { alpha2: "BJ", alpha3: "BEN", name: "Benin" },
    { alpha2: "BM", alpha3: "BMU", name: "Bermuda" },
    { alpha2: "BT", alpha3: "BTN", name: "Bhutan" },
    { alpha2: "BO", alpha3: "BOL", name: "Bolivia" },
    { alpha2: "BQ", alpha3: "BES", name: "Bonaire, Saint Eustatius and Saba" },
    { alpha2: "BA", alpha3: "BIH", name: "Bosnia and Herzegovina" },
    { alpha2: "IO", alpha3: "IOT", name: "British Indian Ocean Territory", aliases:["Brit Ind Ocn Tr"] },
    { alpha2: "BW", alpha3: "BWA", name: "Botswana" },
    { alpha2: "BV", alpha3: "BVT", name: "Bouvet Island" },
    { alpha2: "BR", alpha3: "BRA", name: "Brazil" },
    { alpha2: "BN", alpha3: "BRN", name: "Brunei" },
    { alpha2: "BG", alpha3: "BGR", name: "Bulgaria" },
    { alpha2: "BF", alpha3: "BFA", name: "Burkina Faso" },
    { alpha2: "BI", alpha3: "BDI", name: "Burundi" },
    { alpha2: "KH", alpha3: "KHM", name: "Cambodia" },
    { alpha2: "CM", alpha3: "CMR", name: "Cameroon" },
    { alpha2: "CA", alpha3: "CAN", name: "Canada" },
    { alpha2: "CV", alpha3: "CPV", name: "Cape Verde" },
    { alpha2: "KY", alpha3: "CYM", name: "Cayman Islands" },
    { alpha2: "CF", alpha3: "CAF", name: "Central African Republic" },
    { alpha2: "TD", alpha3: "TCD", name: "Chad" },
    { alpha2: "CL", alpha3: "CHL", name: "Chile" },
    { alpha2: "CN", alpha3: "CHN", name: "China" },
    { alpha2: "CX", alpha3: "CXR", name: "Christmas Island" },
    { alpha2: "CC", alpha3: "CCK", name: "Cocos Islands" },
    { alpha2: "CO", alpha3: "COL", name: "Colombia" },
    { alpha2: "KM", alpha3: "COM", name: "Comoros" },
    { alpha2: "CK", alpha3: "COK", name: "Cook Islands" },
    { alpha2: "CR", alpha3: "CRI", name: "Costa Rica" },
    { alpha2: "CI", alpha3: "CIV", name: "Cote d’Ivoire (Ivory Coast)", aliases:["Ivory Coast"] },
    { alpha2: "HR", alpha3: "HRV", name: "Croatia" },
    { alpha2: "CW", alpha3: "CUW", name: "Curacao" },
    { alpha2: "CY", alpha3: "CYP", name: "Cyprus" },
    { alpha2: "CZ", alpha3: "CZE", name: "Czech Republic" },
    { alpha2: "CD", alpha3: "COD", name: "Democratic Republic of the Congo" },
    { alpha2: "DK", alpha3: "DNK", name: "Denmark" },
    { alpha2: "DJ", alpha3: "DJI", name: "Djibouti" },
    { alpha2: "DM", alpha3: "DMA", name: "Dominica" },
    { alpha2: "DO", alpha3: "DOM", name: "Dominican Republic" },
    { alpha2: "TL", alpha3: "TLS", name: "Timor-Leste", aliases:["Timor Leste","East Timor"] },
    { alpha2: "EC", alpha3: "ECU", name: "Ecuador" },
    { alpha2: "EG", alpha3: "EGY", name: "Egypt" },
    { alpha2: "SV", alpha3: "SLV", name: "El Salvador" },
    { alpha2: "GQ", alpha3: "GNQ", name: "Equatorial Guinea" },
    { alpha2: "ER", alpha3: "ERI", name: "Eritrea" },
    { alpha2: "EE", alpha3: "EST", name: "Estonia" },
    { alpha2: "ET", alpha3: "ETH", name: "Ethiopia" },
    { alpha2: "FK", alpha3: "FLK", name: "Falkland Islands" },
    { alpha2: "FO", alpha3: "FRO", name: "Faroe Islands" },
    { alpha2: "FJ", alpha3: "FJI", name: "Fiji" },
    { alpha2: "FI", alpha3: "FIN", name: "Finland", aliases:["Esri Finland", "Esri Finland Oy"] },
    { alpha2: "MK", alpha3: "MKD", name: "Former Yugoslav Rep. of Macedonia (FYROM)" },
    { alpha2: "FR", alpha3: "FRA", name: "France" },
    { alpha2: "GF", alpha3: "GUF", name: "French Guiana" },
    { alpha2: "PF", alpha3: "PYF", name: "French Polynesia" },
    { alpha2: "GA", alpha3: "GAB", name: "Gabon" },
    { alpha2: "GM", alpha3: "GMB", name: "Gambia" },
    { alpha2: "GE", alpha3: "GEO", name: "Georgia" },
    { alpha2: "DE", alpha3: "DEU", name: "Germany", aliases:["Deutschland", "Esri Deutschland", "Esri Deutschland GmbH", "Esri Germany"]},
    { alpha2: "GH", alpha3: "GHA", name: "Ghana" },
    { alpha2: "GI", alpha3: "GIB", name: "Gibraltar" },
    { alpha2: "GR", alpha3: "GRC", name: "Greece" },
    { alpha2: "GL", alpha3: "GRL", name: "Greenland" },
    { alpha2: "GD", alpha3: "GRD", name: "Grenada" },
    { alpha2: "GP", alpha3: "GLP", name: "Guadeloupe" },
    { alpha2: "GU", alpha3: "GUM", name: "Guam" },
    { alpha2: "GT", alpha3: "GTM", name: "Guatemala" },
    { alpha2: "GG", alpha3: "GGY", name: "Guernsey" },
    { alpha2: "GN", alpha3: "GIN", name: "Guinea" },
    { alpha2: "GW", alpha3: "GNB", name: "Guinea Bissau" },
    { alpha2: "GY", alpha3: "GUY", name: "Guyana" },
    { alpha2: "HT", alpha3: "HTI", name: "Haiti" },
    { alpha2: "HM", alpha3: "HMD", name: "Heard Island and McDonald Islands", aliases:["Heard Island","McDonald Islands"]},
    { alpha2: "HN", alpha3: "HND", name: "Honduras" },
    { alpha2: "HK", alpha3: "HKG", name: "Hong Kong" },
    { alpha2: "HU", alpha3: "HUN", name: "Hungary" },
    { alpha2: "IS", alpha3: "ISL", name: "Iceland" },
    { alpha2: "IN", alpha3: "IND", name: "India" },
    { alpha2: "ID", alpha3: "IDN", name: "Indonesia" },
    { alpha2: "IR", alpha3: "IRN", name: "Iran" , aliases:["Islamic Republic of Iran","Iran, Islamic Republic of"]},
    { alpha2: "IQ", alpha3: "IRQ", name: "Iraq" },
    { alpha2: "IE", alpha3: "IRL", name: "Ireland, Republic of Eire", aliases:["Ireland"] },
    { alpha2: "IM", alpha3: "IMN", name: "Isle of Man" },
    { alpha2: "IL", alpha3: "ISR", name: "Israel", aliases:["ישראל","מפות","מפת"] }, 
    { alpha2: "IT", alpha3: "ITA", name: "Italy" },
    { alpha2: "JM", alpha3: "JAM", name: "Jamaica" },
    { alpha2: "JP", alpha3: "JPN", name: "Japan" },
    { alpha2: "JE", alpha3: "JEY", name: "Jersey" },
    { alpha2: "JO", alpha3: "JOR", name: "Jordan", aliases: ["الأردن"] },
    { alpha2: "KZ", alpha3: "KAZ", name: "Kazakhstan" },
    { alpha2: "KE", alpha3: "KEN", name: "Kenya" },
    { alpha2: "KI", alpha3: "KIR", name: "Kiribati" },
    { alpha2: "XK", alpha3: "RKS", name: "Kosovo" },
    { alpha2: "KW", alpha3: "KWT", name: "Kuwait" },
    { alpha2: "KG", alpha3: "KGZ", name: "Kyrgyzstan" },
    { alpha2: "LA", alpha3: "LAO", name: "Laos" },
    { alpha2: "LV", alpha3: "LVA", name: "Latvia" },
    { alpha2: "LB", alpha3: "LBN", name: "Lebanon" },
    { alpha2: "LS", alpha3: "LSO", name: "Lesotho" },
    { alpha2: "LR", alpha3: "LBR", name: "Liberia" },
    { alpha2: "LY", alpha3: "LBY", name: "Libya" },
    { alpha2: "LI", alpha3: "LIE", name: "Liechtenstein" },
    { alpha2: "LT", alpha3: "LTU", name: "Lithuania" },
    { alpha2: "LU", alpha3: "LUX", name: "Luxembourg" },
    { alpha2: "MO", alpha3: "MAC", name: "Macau" },
    { alpha2: "MG", alpha3: "MDG", name: "Madagascar" },
    { alpha2: "MW", alpha3: "MWI", name: "Malawi" },
    { alpha2: "MY", alpha3: "MYS", name: "Malaysia" },
    { alpha2: "MV", alpha3: "MDV", name: "Maldives" },
    { alpha2: "ML", alpha3: "MLI", name: "Mali" },
    { alpha2: "MT", alpha3: "MLT", name: "Malta" },
    { alpha2: "MH", alpha3: "MHL", name: "Marshall Island" },
    { alpha2: "MQ", alpha3: "MTQ", name: "Martinique" },
    { alpha2: "MR", alpha3: "MRT", name: "Mauritania" },
    { alpha2: "MU", alpha3: "MUS", name: "Mauritius" },
    { alpha2: "YT", alpha3: "MYT", name: "Mayotte" },
    { alpha2: "MX", alpha3: "MEX", name: "Mexico" },
    { alpha2: "FM", alpha3: "FSM", name: "Micronesia" },
    { alpha2: "MD", alpha3: "MDA", name: "Moldova" },
    { alpha2: "MC", alpha3: "MCO", name: "Monaco" },
    { alpha2: "MN", alpha3: "MNG", name: "Mongolia" },
    { alpha2: "ME", alpha3: "MNE", name: "Montenegro" },
    { alpha2: "MS", alpha3: "MSR", name: "Montserrat" },
    { alpha2: "MA", alpha3: "MAR", name: "Morocco" },
    { alpha2: "MZ", alpha3: "MOZ", name: "Mozambique" },
    { alpha2: "MM", alpha3: "MMR", name: "Myanmar" },
    { alpha2: "NA", alpha3: "NAM", name: "Namibia" },
    { alpha2: "NR", alpha3: "NRU", name: "Nauru" },
    { alpha2: "NP", alpha3: "NPL", name: "Nepal" },
    { alpha2: "NL", alpha3: "NLD", name: "Netherlands" },
    { alpha2: "NC", alpha3: "NCL", name: "New Caledonia" },
    { alpha2: "NZ", alpha3: "NZL", name: "New Zealand" },
    { alpha2: "NI", alpha3: "NIC", name: "Nicaragua" },
    { alpha2: "NE", alpha3: "NER", name: "Niger" },
    { alpha2: "NG", alpha3: "NGA", name: "Nigeria" },
    { alpha2: "NU", alpha3: "NIU", name: "Niue" },
    { alpha2: "NF", alpha3: "NFK", name: "Norfolk Island" },
    { alpha2: "MP", alpha3: "MNP", name:"Northern Mariana Islands", aliases:["North Mariana"] }, 
    { alpha2: "NO", alpha3: "NOR", name: "Norway" },
    { alpha2: "OM", alpha3: "OMN", name: "Oman" },
    { alpha2: "PK", alpha3: "PAK", name: "Pakistan" },
    { alpha2: "PW", alpha3: "PLW", name: "Palau" },
    { alpha2: "PA", alpha3: "PAN", name: "Panama" },
    { alpha2: "PG", alpha3: "PNG", name: "Papua New Guinea" },
    { alpha2: "PY", alpha3: "PRY", name: "Paraguay" },
    { alpha2: "PE", alpha3: "PER", name: "Peru" },
    { alpha2: "PH", alpha3: "PHL", name: "Philippines" },
    { alpha2: "PN", alpha3: "PCN", name: "Pitcairn" },
    { alpha2: "PL", alpha3: "POL", name: "Poland" },
    { alpha2: "PT", alpha3: "PRT", name: "Portugal" },
    { alpha2: "PR", alpha3: "PRI", name: "Puerto Rico" },
    { alpha2: "QA", alpha3: "QAT", name: "Qatar" },
    { alpha2: "CG", alpha3: "COG", name: "Republic of the Congo" },
    { alpha2: "RE", alpha3: "REU", name: "Reunion" },
    { alpha2: "RO", alpha3: "ROU", name: "Romania" },
    { alpha2: "RU", alpha3: "RUS", name: "Russia" },
    { alpha2: "RW", alpha3: "RWA", name: "Rwanda" },
    { alpha2: "BL", alpha3: "BLM", name: "Saint Barthelemy" },
    { alpha2: "SH", alpha3: "SHN", name: "Saint Helena" },
    { alpha2: "MF", alpha3: "MAF", name: "Saint Martin" },
    { alpha2: "PM", alpha3: "SPM", name: "Saint Pierre and Miquelon" },
    { alpha2: "WS", alpha3: "WSM", name: "Samoa" },
    { alpha2: "SM", alpha3: "SMR", name: "San Marino" },
    { alpha2: "ST", alpha3: "STP", name: "Sao Tome and Principe" },
    { alpha2: "SA", alpha3: "SAU", name: "Saudi Arabia" },
    { alpha2: "SN", alpha3: "SEN", name: "Senegal" },
    { alpha2: "RS", alpha3: "SRB", name: "Serbia" },
    { alpha2: "SC", alpha3: "SYC", name: "Seychelles" },
    { alpha2: "SL", alpha3: "SLE", name: "Sierra Leone" },
    { alpha2: "SG", alpha3: "SGP", name: "Singapore" },
    { alpha2: "SX", alpha3: "SXM", name: "Sint Maarten (Dutch part)" },
    { alpha2: "SK", alpha3: "SVK", name: "Slovakia" },
    { alpha2: "SI", alpha3: "SVN", name: "Slovenia" },
    { alpha2: "SB", alpha3: "SLB", name: "Solomon Islands" },
    { alpha2: "SO", alpha3: "SOM", name: "Somalia" },
    { alpha2: "ZA", alpha3: "ZAF", name: "South Africa" },
    { alpha2: "GS", alpha3: "SGS", name: "South Georgia and the South Sandwich Islands" },
    { alpha2: "KR", alpha3: "KOR", name: "South Korea", aliases:["Korea","Esri Korea, Inc."]},
    { alpha2: "SS", alpha3: "SSD", name: "South Sudan" },
    { alpha2: "ES", alpha3: "ESP", name: "Spain" },
    { alpha2: "LK", alpha3: "LKA", name: "Sri Lanka" },
    { alpha2: "KN", alpha3: "KNA", name: "St. Kitts and Nevis" },
    { alpha2: "LC", alpha3: "LCA", name: "St. Lucia" },
    { alpha2: "VC", alpha3: "VCT", name: "St. Vincent" },
    { alpha2: "SD", alpha3: "SDN", name: "Sudan" },
    { alpha2: "SR", alpha3: "SUR", name: "Suriname" },
    { alpha2: "SJ", alpha3: "SJM", name:"Svalbard and Jan Mayen", aliases:["Svalbard & Jan Mayen Is."]}, 
    { alpha2: "SZ", alpha3: "SWZ", name: "Swaziland" },
    { alpha2: "SE", alpha3: "SWE", name: "Sweden", aliases:["Esri Sverige AB"] },
    { alpha2: "CH", alpha3: "CHE", name: "Switzerland" },
    { alpha2: "SY", alpha3: "SYR", name: "Syria" },
    { alpha2: "TW", alpha3: "TWN", name: "Taiwan" },
    { alpha2: "TJ", alpha3: "TJK", name: "Tajikistan" },
    { alpha2: "TZ", alpha3: "TZA", name: "Tanzania" },
    { alpha2: "TH", alpha3: "THA", name: "Thailand" },
    { alpha2: "BS", alpha3: "BHS", name: "The Bahamas" },
    { alpha2: "TG", alpha3: "TGO", name: "Togo" },
    { alpha2: "TK", alpha3: "TKL", name: "Tokelau" },
    { alpha2: "TO", alpha3: "TON", name: "Tonga" },
    { alpha2: "TT", alpha3: "TTO", name: "Trinidad and Tobago" },
    { alpha2: "TN", alpha3: "TUN", name: "Tunisia" },
    { alpha2: "TR", alpha3: "TUR", name: "Turkey" },
    { alpha2: "TM", alpha3: "TKM", name: "Turkmenistan" },
    { alpha2: "TC", alpha3: "TCA", name: "Turks and Caicos Islands" },
    { alpha2: "TV", alpha3: "TUV", name: "Tuvalu" },
    { alpha2: "UG", alpha3: "UGA", name: "Uganda" },
    { alpha2: "UA", alpha3: "UKR", name: "Ukraine" },
    { alpha2: "AE", alpha3: "ARE", name: "United Arab Emirates", aliases:["UAE", "U.A.E."]},
    { alpha2: "GB", alpha3: "GBR", name: "United Kingdom", aliases:["Great Britain", "Northern Ireland"]},
    { alpha2: "UK", alpha3: "GBR", name: "United Kingdom" },
    { alpha2: "US", alpha3: "USA", name: "United States of America", aliases:["USA","United States","Esri Redlands", "Redlands", "Esri Headquarters"] },
    { alpha2: "UM", alpha3: "UMI", name: "United States Minor Outlying Islands" },
    { alpha2: "UY", alpha3: "URY", name: "Uruguay" },
    { alpha2: "UZ", alpha3: "UZB", name: "Uzbekistan" },
    { alpha2: "VU", alpha3: "VUT", name: "Vanuatu" },
    { alpha2: "VA", alpha3: "VAT", name: "Vatican City" },
    { alpha2: "VE", alpha3: "VEN", name: "Venezuela" },
    { alpha2: "VN", alpha3: "VNM", name: "Vietnam" },
    { alpha2: "VG", alpha3: "VGB", name: "Virgin Islands (British)" },
    { alpha2: "VI", alpha3: "VIR", name: "Virgin Islands (U.S.)" },
    { alpha2: "WF", alpha3: "WLF", name: "Wallis and Futuna" },
    { alpha2: "EH", alpha3: "ESH", name: "Western Sahara" },
    { alpha2: "YE", alpha3: "YEM", name: "Yemen" },
    { alpha2: "ZM", alpha3: "ZMB", name: "Zambia" },
    { alpha2: "ZW", alpha3: "ZWE", name: "Zimbabwe" },
    { alpha2: "KP", alpha3: "PRK", name: "North Korea" },
    { alpha2: "CU", alpha3: "CUB", name: "Cuba" }
  ],
  embargoedCountryAlpha3list:[
    { alpha2: "CU", alpha3: "CUB", name: "Cuba" },
    { alpha2: "IR", alpha3: "IRN", name: "Iran"},
    { alpha2: "KP", alpha3: "PRK", name: "North Korea"},
    { alpha2: "SY", alpha3: "SYR", name: "Syria" }
  ],
  countryAlpha2List:[
    { alpha2:"af", name:"Afghanistan" }, 
    { alpha2:"al", name:"Albania" }, 
    { alpha2:"dz", name:"Algeria" }, 
    { alpha2:"as", name:"American Samoa" }, 
    { alpha2:"ad", name:"Andorra" }, 
    { alpha2:"ao", name:"Angola" }, 
    { alpha2:"ai", name:"Anguilla" }, 
    { alpha2:"aq", name:"Antarctica" }, 
    { alpha2:"ag", name:"Antigua/Barbuda" }, 
    { alpha2:"ar", name:"Argentina" }, 
    { alpha2:"am", name:"Armenia" }, 
    { alpha2:"aw", name:"Aruba" }, 
    { alpha2:"au", name:"Australia" }, 
    { alpha2:"at", name:"Austria" }, 
    { alpha2:"az", name:"Azerbaijan" }, 
    { alpha2:"bs", name:"Bahamas" }, 
    { alpha2:"bh", name:"Bahrain" }, 
    { alpha2:"bd", name:"Bangladesh" }, 
    { alpha2:"bb", name:"Barbados" }, 
    { alpha2:"by", name:"Belarus" }, 
    { alpha2:"be", name:"Belgium" }, 
    { alpha2:"bz", name:"Belize" }, 
    { alpha2:"bj", name:"Benin" }, 
    { alpha2:"bm", name:"Bermuda" }, 
    { alpha2:"bt", name:"Bhutan" }, 
    { alpha2:"bo", name:"Bolivia" }, 
    { alpha2:"bq", name:"Bonaire, Sint Eustatius, Saba" }, 
    { alpha2:"ba", name:"Bosnia and Herzegovina" }, 
    { alpha2:"bw", name:"Botswana" }, 
    { alpha2:"bv", name:"Bouvet Island" }, 
    { alpha2:"br", name:"Brazil" }, 
    { alpha2:"io", name:"Brit Ind Ocn Tr" }, 
    { alpha2:"bn", name:"Brunei" }, 
    { alpha2:"bg", name:"Bulgaria" }, 
    { alpha2:"bf", name:"Burkina Faso" }, 
    { alpha2:"bi", name:"Burundi" }, 
    { alpha2:"kh", name:"Cambodia" }, 
    { alpha2:"cm", name:"Cameroon" }, 
    { alpha2:"ca", name:"Canada" }, 
    { alpha2:"cv", name:"Cape Verde" }, 
    { alpha2:"ky", name:"Cayman Islands" }, 
    { alpha2:"cf", name:"Central African Republic" }, 
    { alpha2:"td", name:"Chad" }, 
    { alpha2:"cl", name:"Chile" }, 
    { alpha2:"cn", name:"China" }, 
    { alpha2:"cx", name:"Christmas Island" }, 
    { alpha2:"cc", name:"Cocos Islands" }, 
    { alpha2:"co", name:"Colombia" }, 
    { alpha2:"km", name:"Comoros" }, 
    { alpha2:"cd", name:"Congo, Democratic Republic of" }, 
    { alpha2:"cg", name:"Congo, Republic of" }, 
    { alpha2:"ck", name:"Cook Islands" }, 
    { alpha2:"cr", name:"Costa Rica" }, 
    { alpha2:"ci", name:"Cote D’ivoire (Ivory Coast)" }, 
    { alpha2:"hr", name:"Croatia" }, 
    { alpha2:"cu", name:"Cuba" }, 
    { alpha2:"cw", name:"Curacao" }, 
    { alpha2:"cy", name:"Cyprus" }, 
    { alpha2:"cz", name:"Czech Republic" }, 
    { alpha2:"dk", name:"Denmark" }, 
    { alpha2:"dj", name:"Djibouti" }, 
    { alpha2:"dm", name:"Dominica" }, 
    { alpha2:"do", name:"Dominican Republic" }, 
    { alpha2:"tl", name:"Timor-Leste" }, 
    { alpha2:"ec", name:"Ecuador" }, 
    { alpha2:"eg", name:"Egypt" }, 
    { alpha2:"sv", name:"El Salvador" }, 
    { alpha2:"gq", name:"Equatorial Guinea" }, 
    { alpha2:"er", name:"Eritrea" }, 
    { alpha2:"ee", name:"Estonia" }, 
    { alpha2:"et", name:"Ethiopia" }, 
    { alpha2:"mk", name:"Former Yugoslav Rep. of Macedonia (FYROM)" }, 
    { alpha2:"fk", name:"Falkland Islands" },
    { alpha2:"fo", name:"Faroe Islands" }, 
    { alpha2:"fj", name:"Fiji" }, 
    { alpha2:"fi", name:"Finland" }, 
    { alpha2:"fr", name:"France" }, 
    { alpha2:"gf", name:"French Guiana" }, 
    { alpha2:"pf", name:"French Polynesia" }, 
    { alpha2:"ga", name:"Gabon" }, 
    { alpha2:"gm", name:"Gambia" }, 
    { alpha2:"ge", name:"Georgia" }, 
    { alpha2:"de", name:"Germany" }, 
    { alpha2:"gh", name:"Ghana" }, 
    { alpha2:"gi", name:"Gibraltar" }, 
    { alpha2:"gb", name:"Great Britain" }, 
    { alpha2:"gr", name:"Greece" }, 
    { alpha2:"gl", name:"Greenland" }, 
    { alpha2:"gd", name:"Grenada" }, 
    { alpha2:"gp", name:"Guadeloupe" }, 
    { alpha2:"gu", name:"Guam" }, 
    { alpha2:"gt", name:"Guatemala" }, 
    { alpha2:"gg", name:"Guernsey" }, 
    { alpha2:"gn", name:"Guinea" }, 
    { alpha2:"gw", name:"Guinea-Bissau" }, 
    { alpha2:"gy", name:"Guyana" }, 
    { alpha2:"ht", name:"Haiti" }, 
    { alpha2:"hm", name:"Heard Island and McDonald Islands" }, 
    { alpha2:"hn", name:"Honduras" }, 
    { alpha2:"hk", name:"Hong Kong" }, 
    { alpha2:"hu", name:"Hungary" }, 
    { alpha2:"is", name:"Iceland" }, 
    { alpha2:"in", name:"India" }, 
    { alpha2:"id", name:"Indonesia" }, 
    { alpha2:"ir", name:"Iran" }, 
    { alpha2:"iq", name:"Iraq" }, 
    { alpha2:"ie", name:"Ireland, Northern" }, 
    { alpha2:"ie", name:"Ireland/Eire, Republic of" }, 
    { alpha2:"im", name:"Isle of Man" }, 
    { alpha2:"il", name:"Israel" }, 
    { alpha2:"it", name:"Italy" }, 
    { alpha2:"jm", name:"Jamaica" }, 
    { alpha2:"jp", name:"Japan" }, 
    { alpha2:"je", name:"Jersey" }, 
    { alpha2:"jo", name:"Jordan" }, 
    { alpha2:"kz", name:"Kazakhstan" }, 
    { alpha2:"ke", name:"Kenya" }, 
    { alpha2:"ki", name:"Kiribati" }, 
    { alpha2:"kp", name:"Korea, North" }, 
    { alpha2:"kr", name:"Korea, South" }, 
    { alpha2:"kw", name:"Kuwait" }, 
    { alpha2:"kg", name:"Kyrgyzstan" }, 
    { alpha2:"la", name:"Laos" }, 
    { alpha2:"lv", name:"Latvia" }, 
    { alpha2:"lb", name:"Lebanon" }, 
    { alpha2:"ls", name:"Lesotho" }, 
    { alpha2:"lr", name:"Liberia" }, 
    { alpha2:"ly", name:"Libya" }, 
    { alpha2:"li", name:"Liechtenstein" }, 
    { alpha2:"lt", name:"Lithuania" }, 
    { alpha2:"lu", name:"Luxembourg" }, 
    { alpha2:"mo", name:"Macau" }, 
    { alpha2:"mg", name:"Madagascar" }, 
    { alpha2:"mw", name:"Malawi" }, 
    { alpha2:"my", name:"Malaysia" }, 
    { alpha2:"mv", name:"Maldives" }, 
    { alpha2:"ml", name:"Mali" }, 
    { alpha2:"mt", name:"Malta" }, 
    { alpha2:"mh", name:"Marshall Island" }, 
    { alpha2:"mq", name:"Martinique" }, 
    { alpha2:"mr", name:"Mauritania" }, 
    { alpha2:"mu", name:"Mauritius" }, 
    { alpha2:"yt", name:"Mayotte" }, 
    { alpha2:"mx", name:"Mexico" }, 
    { alpha2:"fm", name:"Micronesia" }, 
    { alpha2:"md", name:"Moldova" }, 
    { alpha2:"mc", name:"Monaco" }, 
    { alpha2:"mn", name:"Mongolia" }, 
    { alpha2:"me", name:"Montenegro" }, 
    { alpha2:"ms", name:"Montserrat" }, 
    { alpha2:"ma", name:"Morocco" }, 
    { alpha2:"mz", name:"Mozambique" }, 
    { alpha2:"mm", name:"Myanmar" }, 
    { alpha2:"na", name:"Namibia" }, 
    { alpha2:"nr", name:"Nauru" }, 
    { alpha2:"np", name:"Nepal" }, 
    { alpha2:"nl", name:"Netherlands" }, 
    { alpha2:"an", name:"Netherlands Antilles" }, 
    { alpha2:"nc", name:"New Caledonia" }, 
    { alpha2:"nz", name:"New Zealand" }, 
    { alpha2:"ni", name:"Nicaragua" }, 
    { alpha2:"ne", name:"Niger" }, 
    { alpha2:"ng", name:"Nigeria" }, 
    { alpha2:"nu", name:"Niue" }, 
    { alpha2:"nf", name:"Norfolk Island" }, 
    { alpha2:"mp", name:"Northern Mariana Islands" }, 
    { alpha2:"no", name:"Norway" }, 
    { alpha2:"om", name:"Oman" }, 
    { alpha2:"pk", name:"Pakistan" }, 
    { alpha2:"pw", name:"Palau" }, 
    { alpha2:"pa", name:"Panama" }, 
    { alpha2:"pg", name:"Papua New Guinea" }, 
    { alpha2:"py", name:"Paraguay" }, 
    { alpha2:"pe", name:"Peru" }, 
    { alpha2:"ph", name:"Philippines" }, 
    { alpha2:"pn", name:"Pitcairn" }, 
    { alpha2:"pl", name:"Poland" }, 
    { alpha2:"pt", name:"Portugal" }, 
    { alpha2:"pr", name:"Puerto Rico" }, 
    { alpha2:"qa", name:"Qatar" }, 
    { alpha2:"re", name:"Reunion" }, 
    { alpha2:"ro", name:"Romania" }, 
    { alpha2:"ru", name:"Russia" }, 
    { alpha2:"rw", name:"Rwanda" }, 
    { alpha2:"ws", name:"Samoa" }, 
    { alpha2:"sm", name:"San Marino" }, 
    { alpha2:"st", name:"Sao Tome and Principe" }, 
    { alpha2:"sa", name:"Saudi Arabia" }, 
    { alpha2:"sn", name:"Senegal" }, 
    { alpha2:"rs", name:"Serbia" }, 
    { alpha2:"sc", name:"Seychelles" }, 
    { alpha2:"sl", name:"Sierra Leone" }, 
    { alpha2:"sg", name:"Singapore" }, 
    { alpha2:"sx", name:"Sint Maarten" }, 
    { alpha2:"sk", name:"Slovak Republic" }, 
    { alpha2:"si", name:"Slovenia" }, 
    { alpha2:"sb", name:"Solomon Islands" }, 
    { alpha2:"so", name:"Somalia" }, 
    { alpha2:"za", name:"South Africa" }, 
    { alpha2:"gs", name:"South Georgia and the South Sandwich Islands" }, 
    { alpha2:"es", name:"Spain" }, 
    { alpha2:"lk", name:"Sri Lanka" }, 
    { alpha2:"sh", name:"St. Helena" }, 
    { alpha2:"kn", name:"St. Kitts and Nevis" }, 
    { alpha2:"lc", name:"St. Lucia" }, 
    { alpha2:"pm", name:"St. Pierre and Miquelon" }, 
    { alpha2:"vc", name:"St. Vincent" }, 
    { alpha2:"sd", name:"Sudan" }, 
    { alpha2:"ss", name:"South Sudan" }, 
    { alpha2:"sr", name:"Suriname" }, 
    { alpha2:"sj", name:"Svalbard & Jan Mayen Is." }, 
    { alpha2:"sz", name:"Swaziland" }, 
    { alpha2:"se", name:"Sweden" }, 
    { alpha2:"ch", name:"Switzerland" }, 
    { alpha2:"sy", name:"Syria" }, 
    { alpha2:"tw", name:"Taiwan" }, 
    { alpha2:"tj", name:"Tajikistan" }, 
    { alpha2:"tz", name:"Tanzania" }, 
    { alpha2:"th", name:"Thailand" }, 
    { alpha2:"tg", name:"Togo" }, 
    { alpha2:"tk", name:"Tokelau" }, 
    { alpha2:"to", name:"Tonga" }, 
    { alpha2:"tt", name:"Trinidad & Tobago" }, 
    { alpha2:"tn", name:"Tunisia" }, 
    { alpha2:"tr", name:"Turkey" }, 
    { alpha2:"tm", name:"Turkmenistan" }, 
    { alpha2:"tc", name:"Turks and Caicos Islands" }, 
    { alpha2:"tv", name:"Tuvalu" }, 
    { alpha2:"ug", name:"Uganda" }, 
    { alpha2:"ua", name:"Ukraine" }, 
    { alpha2:"ae", name:"United Arab Emirates" }, 
    { alpha2:"uk", name:"United Kingdom" }, 
    { alpha2:"us", name:"United States of America" }, 
    { alpha2:"us", name:"USA" }, 
    { alpha2:"us", name:"United States" }, 
    { alpha2:"uy", name:"Uruguay" }, 
    { alpha2:"uz", name:"Uzbekistan" }, 
    { alpha2:"vu", name:"Vanuatu" }, 
    { alpha2:"va", name:"Vatican City" }, 
    { alpha2:"ve", name:"Venezuela" }, 
    { alpha2:"vn", name:"Vietnam" }, 
    { alpha2:"vg", name:"Virgin Islands (British)" }, 
    { alpha2:"vi", name:"Virgin Islands (U.S.)" }, 
    { alpha2:"wf", name:"Wallis and Futuna" }, 
    { alpha2:"eh", name:"Western Sahara" }, 
    { alpha2:"ye", name:"Yemen" }, 
    { alpha2:"zm", name:"Zambia" }, 
    { alpha2:"zw", name:"Zimbabwe" }
  ],
  usRegionalOffices: [
    {
      officeName: 'Esri Olympia',
      officeCode: 'OLY',
      state: 'US-WA',
      serves: ['US-AK', 'US-ID', 'US-MT', 'US-OR', 'US-WA']
    },
    {
      officeName: 'Esri California',
      officeCode: 'CAL',
      state: 'US-CA',
      serves: ['US-CA', 'US-HI', 'US-NV', 'GU', 'AS', 'PW', 'MH', 'FM']
    },
    {
      officeName: 'Esri Denver',
      officeCode: 'DEN',
      state: 'US-CO',
      serves: ['US-AZ', 'US-CO', 'US-NM', 'US-UT', 'US-WY']
    },
    {
      officeName: 'Esri Minneapolis',
      officeCode: 'MIN',
      state: 'US-MN',
      serves: ['US-IL', 'US-IN', 'US-MI', 'US-MN', 'US-ND', 'US-OH', 'US-SD', 'US-WI']
    },
    {
      officeName: 'Esri St. Louis',
      officeCode: 'STL',
      state: 'US-MO',
      serves: ['US-AR', 'US-IA', 'US-KS', 'US-KY', 'US-MO', 'US-NE']
    },
    {
      officeName: 'Esri San Antonio',
      officeCode: 'SAN',
      state: 'US-TX',
      serves: ['US-LA', 'US-MS', 'US-OK', 'US-TX', 'KY']
    },
    {
      officeName: 'Esri Charlotte Arboretum',
      officeCode: 'CLT',
      state: 'US-NC',
      serves: ['US-AL', 'US-FL', 'US-GA', 'US-NC', 'US-SC', 'US-TN', 'US-VA', 'US-WV', 'BM']
    },
    {
      officeName: 'Esri Charlotte Waverly',
      officeCode: 'CLTW',
      state: 'US-NC',
      serves: ['US-AL', 'US-FL', 'US-GA', 'US-NC', 'US-SC', 'US-TN', 'US-VA', 'US-WV', 'BM']
    },
    {
      officeName: 'Esri Philadelphia',
      officeCode: 'PHL',
      state: 'US-PA',
      incudesRegionsInState: {
        state: 'US-NY',
        cities: ['New Your City', 'Long Island']
      },
      serves: ['US-DE', 'US-DC', 'US-MD', 'US-NJ', 'US-NY', 'US-PA']
    },
    {
      officeName: 'Esri Boston',
      officeCode: 'BOS',
      state: 'US-MA',
      excudesRegionsInState: {
        state: 'US-NY',
        cities: ['New Your City', 'Long Island']
      },
      serves: ['US-CT', 'US-ME', 'US-MA', 'US-NH', 'US-RI', 'US-VT']
    },
    {
      officeName: 'Esri Washington, DC',
      officeCode: 'WDC',
      state: 'US-VA',
      serves: ['US-DC']
    }
  ],
  modified:'190828'
}
window.contactUsData = contactUsData;
